"use client";

import { useEffect } from "react";
import { reportClientError } from "@/lib/error-log/client";

/**
 * Next.js root error boundary — catches anything that escapes every
 * segment boundary, including root-layout crashes. Renders its own
 * <html>/<body> because the root is gone.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportClientError(error, {
      source: "server",
      errorType: error.name ?? "GlobalError",
      context: error.digest
        ? { digest: error.digest, boundary: "global" }
        : { boundary: "global" },
    });
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#fcfaf8",
          fontFamily: "ui-sans-serif, system-ui, sans-serif",
          color: "#28030f",
          padding: 24,
        }}
      >
        <div style={{ maxWidth: 420, textAlign: "center" }}>
          <h1 style={{ fontSize: 22, margin: "0 0 8px", fontWeight: 600 }}>
            Something broke
          </h1>
          <p style={{ fontSize: 14, color: "#6b5a52", margin: "0 0 20px", lineHeight: 1.55 }}>
            The error has been logged. You can try again, or reload the page.
          </p>
          <button
            type="button"
            onClick={reset}
            style={{
              padding: "8px 18px",
              fontSize: 13,
              fontWeight: 500,
              background: "#28030f",
              color: "white",
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
